export default function Beta(){
    return(
        window.location.assign('https://bit.ly/UjiCobaAplikasiKhair')
    )
}